import speech from './speech'
export default speech
